<template>
  <div class="search">
    <el-form class="searchform" v-show="!showInfo" :class="{'search-hidden':search_hidden}" :style="{'height':search_height}" ref="form" :model="form" label-width="80px" label-position="left">
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">會員編號</label>
            <el-input v-model="form.customer_num" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">電話號碼</label>
            <el-input v-model="form.phone" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">會員姓名</label>
            <el-input v-model="form.name" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">證件編號</label>
            <el-input v-model="form.card" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">狀態</label>
            <el-select v-model="form.status" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="Active 有效" value="0"></el-option>
              <el-option label="Suspended 暫停交易" value="1"></el-option>
              <el-option label="Terminated 終止業務關係" value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">類別</label>
            <el-select v-model="form.type" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="個人" value="0"></el-option>
              <el-option label="企業" value="1"></el-option>
              <el-option label="行家" value="2"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">添加時間</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.starttime" style="width: 100%;"></el-date-picker>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.endtime" style="width: 100%;"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">舊會員編號</label>
            <el-input v-model="form.old_customer_num" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">B.R.有效期</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.brstarttime" style="width: 100%;"></el-date-picker>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.brendtime" style="width: 100%;"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">備註</label>
            <el-input v-model="form.remarks" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序字段</label>
            <el-select v-model="form.sortname" placeholder="全部">
              <el-option label="ID" value="id"></el-option>
              <el-option label="會員編號" value="customer_num"></el-option>
              <el-option label="舊會員編號" value="old_customer_num"></el-option>
              <el-option label="B.R.有效期" value="company_card_date"></el-option>
              <el-option label="姓名/公司名稱" value="name"></el-option>
              <el-option label="英文名稱" value="ename"></el-option>
              <el-option label="電話號碼" value="phone"></el-option>
              <el-option label="身份證" value="card"></el-option>
              <el-option label="B.R.證件號碼" value="company_card"></el-option>
              <el-option label="風險評估" value="risk_level"></el-option>
              <el-option label="狀態" value="status"></el-option>
              <el-option label="添加日期" value="addtime"></el-option>
              <el-option label="備註" value="remarks"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序方式</label>
            <div class="mm-row">
              <div class="flex-start">
                <el-radio v-model="form.orderby" label="DESC">由高到低</el-radio>
                <el-radio v-model="form.orderby" label="ASC">由低到高</el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mm-submitbox flexend">
        <el-button @click="search">清除</el-button>
      </div>
    </el-form>
    <div class="rowline mb15" v-show="!showInfo">
      <span class="pointer" v-show="search_hidden" @click="changesearchbox">檢索展開 <i class="el-icon-arrow-down"></i></span>
      <span class="pointer" v-show="!search_hidden" @click="changesearchbox">檢索隱藏 <i class="el-icon-arrow-up"></i></span>
    </div>
    <main v-show="!showInfo">
      <div class="table-box" v-loading="loading" element-loading-text="努力加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
        <el-table :data="customerList" border :header-cell-style="{background:'#FAFAFA'}">
          <el-table-column property="customer_num" label="會員編號" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">會員編號</div>
              <el-link type="primary">{{scope.row.type_text+scope.row.customer_num}}</el-link>
            </template>
          </el-table-column>
          <el-table-column property="old_customer_num" label="舊會員編號" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">舊會員編號</div>
              <el-link type="primary">{{scope.row.old_customer_num}}</el-link>
            </template>
          </el-table-column>
          
          <el-table-column property="company_card_date" label="B.R.有效期" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">B.R.有效期</div>
              {{scope.row.company_card_date}}
            </template>
          </el-table-column>
          <el-table-column property="name" label="姓名/公司名稱" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">姓名/公司名稱</div>
              <el-link type="primary">{{scope.row.name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column property="name" label="英文名稱" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">英文名稱</div>
              <el-link type="primary">{{scope.row.ename}}</el-link>
            </template>
          </el-table-column>
          <!-- <el-table-column property="balance" label="結餘" align="center"></el-table-column> -->
          <el-table-column property="phone" label="電話號碼" align="center">
            <template slot-scope="scope">
              <div class="phonecel">電話號碼</div>
              {{scope.row.phone}}
            </template>
          </el-table-column>
          <el-table-column property="addtime" label="加入時間" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">加入時間</div>
              {{scope.row.addtime}}
            </template>
          </el-table-column>
          <!-- <el-table-column property="count" label="本月交易次數" align="center"></el-table-column> -->
          <!-- <el-table-column property="total" label="本月交易金額(HKD)" align="center"></el-table-column> -->
          <el-table-column property="risk" label="風險評估" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">風險評估</div>
              <div v-if="scope.row.risk_level==2" class="text-red">
                {{scope.row.risk_level_text}}
              </div>
              <div v-if="scope.row.risk_level==1" class="text-orange">
                {{scope.row.risk_level_text}}
              </div>
              <div v-if="scope.row.risk_level==0" class="text-green">
                {{scope.row.risk_level_text}}
              </div>
            </template>
          </el-table-column>
          <el-table-column property="status" label="狀態" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">狀態</div>
              <div :class="scope.row.status==2?'text-red':(scope.row.status==1?'text-orange':'text-green')">
                {{scope.row.status_text}}
              </div>
            </template>
          </el-table-column>
          <el-table-column property="status" label="操作" align="center">
            <template slot-scope="scope">
              <div class="phonecel">操作</div>
              <div>
                <el-button @click="customer_id=scope.row.id;showInfo=true;">詳情</el-button>
                <el-button @click="choose(scope.row.id)">選擇</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom-tool flex-start">
      </div>
    </main>
    <footer v-show="!showInfo" class="mm-row  mt15">
      <div class="coustomernum">
        Total: {{pager.p_count}}個會員
      </div>
      <div>
        <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
        </el-pagination>
      </div>
    </footer>
    <div v-if="showInfo">
      <div class="mm-row mb15 flexend">
        <el-button type="primary" @click="showInfo=false;">返回<i class="el-icon-left"></i></el-button>
      </div>
      <customerinfo :customer_id="customer_id" />
    </div>
    <div class="mb-15"></div>
  </div>
</template>

<script>
import customerinfo from "@/components/CustomerInfo.vue";
export default {
  components: {
    customerinfo
  },
  props: {
    customerData: {
      type: Object,
      default: () => { }
    },
  },
  data () {
    return {
      showInfo: false,
      loading: true,
      dialogCustomerInfo: false,
      customerList: [],
      pager: [],
      search_height: 0,
      search_hidden: true,
      customer_id: 0,
      form: {
        searchType: 1,
        page: 1,
        size: 5,
        name: '',
        phone: "",
        customer_num: "",
        card: "",
        status: "-1",
        type: "-1",
        starttime: '',
        endtime: '',
        brstarttime: '',
        brendtime: '',
        amountsstart: '',
        amountsend: '',
        status: "-1",
        old_customer_num: "",
        remarks:'',
        sortname:'id',
        orderby:'DESC',
      },
      infoData: {
        name: '', // 會員名稱或公司名稱
        type: 0, // 會員類型
        country_id: '', // 國家id
        countryname: "",
        address: "", // 住址
        email: "", // 公司郵箱
        phone: "", // 公司電話/電話號碼
        card: "", // 身份証號碼
        agent: 0, // 是否使用代理
        company_num: "", // 公司編號
        company_card: "", // 商業登記號碼
        company_card_date: "", // 商業登記號碼有效日期
        company_type: "", // 業務性質
        mso_num: "", // MSO編號
        mso_num_date: "", // MSO編號有效期
        // 股東和董事列表
        stockholder: [{
          name: ""
        }],
        // 董事
        director: [{
          name: ''
        }],
        // 獲受人信息 
        authorizer: [{
          name: "",
          phone: ""
        }],
        // 會員文件或公司文件列表
        customer_files: {
          file_list: [], // 旧文件列表
          upload_list: [], // 新上传文件列表
        },
        // 審查結果 Name Screening Result文件列表
        review_files: {
          file_list: [], // 旧文件列表
          upload_list: [], // 新上传文件列表
        },
      },
    }
  },
  methods: {
    changesearchbox () {
      let search_height = this.$refs.form.$el.scrollHeight + 'px';
      if (this.search_hidden) {
        this.search_hidden = false;
        this.search_height = search_height;
      } else {
        this.search_hidden = true;
        this.search_height = 0;
      }
    },
    goByUrl (routerName) {
      this.$router.push({
        name: routerName
      })
    },
    async choose (id) {
      await this.post('/api/customer/customerinfo', {
        customer_id: id
      }).then(res => {
        let customerData = this.customerData;
        // 过滤表格配置传递的参数，如果存在则替换默认值，否则按默认值显示
        if (res.length > 0) {
          // console.log(res);
          let response = res[0];
          for (let key in response) {
            if (customerData.hasOwnProperty(key)) { //把默认配置中的配置项进行替换
              customerData[key] = response[key];
            }
          }

          if (response.files.length > 0) {
            let files = response.files;
            customerData.customer_files_list.length = 0;
            customerData.review_files_list.length = 0;
            files.some(item => {
              if (item.type == 1) {
                let temp = {};
                temp.fileurl = item.fileurl;
                temp.url = this.apiurl + item.fileurl;
                temp.id = item.id;
                temp.files_type = item.files_type;
                temp.files_type_id = item.files_type_id;
                customerData.customer_files_list.push(temp);
              } else if (item.type == 2) {
                let temp = {};
                temp.fileurl = item.fileurl;
                temp.url = this.apiurl + item.fileurl;
                customerData.review_files_list.push(temp);
              }
            });
          } else {
            customerData.customer_files_list = [];
            customerData.review_files_list = [];
          }
        }
        this.$emit('update:customerData', customerData);
      }).catch(error => {
        console.log(error);
      })
      this.$emit('update:visible', false);
    },
    changeSize (val) {
      this.form.size = val;
      this.init();
    },
    changePage (val) {
      this.form.page = val;
      this.init();
    },
    search () {
      this.form.customer_num = '';
      this.form.old_customer_num = '';
      this.form.card = '';
      this.form.name = '';
      this.form.phone = '';
      this.form.starttime = '';
      this.form.endtime = '';
      this.form.brstarttime = '';
      this.form.brendtime = '';
      this.form.status = '-1';
      this.form.type = '-1';
    },
    // 初始化數據
    init () {
      let requestData = this.form;
      this.loading = true;
      this.post('/api/customer/customer_list', requestData)
        .then(response => {
          this.customerList = response.info;
          this.pager = response.pager;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        })
    }

  },
  computed: {},
  created () {
    this.init();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.init();
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.unlink {
  text-decoration: line-through;
  color: #999;
}

.searchform {
  transition: height ease 0.3s;
  overflow: hidden;
}

.rowline {
  border-bottom: 1px solid #66b1ff;
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
  color: #409eff;
  cursor: pointer;
}

.search-hidden {
  height: 0;
  overflow: hidden;
}

.mb15 {
  margin-bottom: 15px;
}

.mt15 {
  margin-top: 15px;
}

.flexend {
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 1024px) {
  .flexend {
    margin-bottom: 20px;
  }
  .search .mm-row {
    margin-bottom: 0;
  }
  .mm-row {
    display: block;
  }
  .mm-col {
    margin-bottom: 10px;
  }
  .coustomernum {
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>
